import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { PosService } from 'src/app/lazy/private/services/pos.service';
import { MainService } from 'src/app/services/main.service';
import { DatePipe } from '@angular/common';
import { DialogService as DS } from '../../../shared/components/dialog/index';
import { ContactslistComponent } from '../contactslist/contactslist.component';

@Component({
  selector: 'app-contacts',
  templateUrl: './contacts.component.html',
  styleUrls: ['./contacts.component.css']
})
export class ContactsComponent implements OnInit {

  @Input() config: any;
  @Output() OnClose: EventEmitter<any> = new EventEmitter<any>();
  model: any;
  data: any = { result: false };
  InvNo: string;
  LocId: string;
  Nations_List: any = [];
  new_data = new Date();
  enableHistory = false;

  constructor( private ps: PosService, private ms: MainService, 
                         private dp: DatePipe, private dS: DS) { }

  ngOnInit() {
    this.data.result = true;
    this.contact_Clear();
    if (this.config.data.Name) {
      this.model = this.config.data;
      this.enableHistory = true;
    } else {
      this.InvNo = this.config.data.InvNo;
      this.LocId = this.config.data.LocId;
    }
  }

  Load_Nation() {
    this.ps.Get_Nationality().subscribe(res => {
      if (res.Success) {
        this.Nations_List = res.data;
        if (this.Nations_List.length != 0) {
          this.model.Nationality = this.Nations_List[0].Name;
        }
        document.getElementById('ph').focus();
      }
    });
  }

  lodaData(invno, isinvNo = true) {
    this.clear_data();
    if (isinvNo) {
      this.ps.Get_Contact_byInvNo({ InvNo: invno, LocId: this.LocId }).subscribe(res => {
        if (res.Success) {
          this.model = res.data;
          this.enableHistory = true;
        }
      });
    } else {
      this.ps.Get_POSContact_byMobileNo({ MobileNo: invno }).subscribe(res => {
        if (res.Success) {
          this.model = res.data;
          this.enableHistory = true;
        }
      });
    }
  }

  keyDown(e, model) {
    if (e.keyCode == 13) {
      if (model == 'PhoneNo') {
        this.lodaData(this.model.PhoneNo, false);
      }
    }
  }

  contact_Clear() {
    this.model = {
      Id: 0,
      Name: '',
      Address: '',
      PhoneNo: '',
      Email: '',
      Gender: 1,
      DOB: this.dp.transform(this.new_data, 'yyyy-MM-dd'),
      Nationality: '',
      InvoiceNumber: ''
    };
    this.Load_Nation();
    this.enableHistory = false;
  }

  clear_data() {
    this.model.Name = '';
    this.model.Address = '';
    this.model.Email = '';
    this.model.Gender = 1;
    this.model.DOB = this.dp.transform(this.new_data, 'yyyy-MM-dd');
    this.model.Nationality = this.Nations_List[0].Name;
    this.enableHistory = false;
  }
  btn_ok() {

    if (this.validateContact()) {
      this.model.InvoiceNumber = this.InvNo;
      this.data.data = this.model;
      this.data.result = true;
      this.OnClose.emit(this.data);
    }
  }

  btn_cancel() {
    this.OnClose.emit();
  }

  validateContact(): boolean {
    if (this.model.PhoneNo == '') {
      alert('Phone No is Empty');
      return false;
    } else if (this.model.Name == '') {
      alert('Name is Empty');
      return false;
    }
    if (this.ms.CommonSetting.ContactFiledMandatory) {
      if (this.model.Nationality == '') {
        alert('Nationality is Empty');
        return false;
      } else if (this.model.Email == '') {
        alert('Email is Empty');
        return false;
      }
    }
    return true;
  }

  searchItem() {

    const data: any = {};
    data['cols'] = [
      { field: 'PhoneNo', header: 'Phone No' },
      { field: 'Name', header: 'Name' },
      { field: 'Email', header: 'Email' },
      { field: 'Nationality', header: 'Nationality' },
    ];
    data['totalCount'] = 0;
    data['serviceName'] = 'GetPOSContactSearch';
    data['enable_Search'] = true;

    this.dS.addDialog(ContactslistComponent, { title: "SEARCH", item: data }).subscribe((res) => {
      if (res.result) {
        this.model.PhoneNo = res.RtnItem.PhoneNo;
        this.lodaData(this.model.PhoneNo, false);
      }
      else {
      }
    });

  }

  searchHistory() {

    const data: any = {};
    data['cols'] = [
      { field: 'InvNo', header: 'Bill No', f: 'text' },
      { field: 'Invdate', header: 'Bill Date', f: 'datetime' },
      { field: 'TotAmount', header: 'Amount', f: 'decimal' },
      { field: 'Location', header: 'Location', f: 'text' },
    ];
    data['totalCount'] = 0;
    data['serviceName'] = 'GetSalesHistoryByContacts';
    data['model'] = this.model.PhoneNo;
    data['enable_Search'] = false;

    this.dS.addDialog(ContactslistComponent, { title: "BILL HISTORY", item: data }).subscribe((res) => {});
  }

}

